import { useState, type ReactNode } from "react";

interface TooltipProps {
  content: string;
  children: ReactNode;
  align?: "left" | "center" | "right";
  asHtml?: boolean;
}

function Tooltip({ content, children, align = "center", asHtml = false }: TooltipProps) {
  const [visible, setVisible] = useState(false);

  if (!content) return <>{children}</>;

  return (
    <span
      className="metric-tooltip"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      <span className="metric-tooltip__label">{children}</span>
      <button
        type="button"
        className="metric-tooltip__icon"
        aria-label="Show metric description"
        onClick={() => setVisible(!visible)}
      >
        i
      </button>
      {visible ? (
        <span
          role="tooltip"
          className={`metric-tooltip__bubble metric-tooltip__bubble--${align}`}
          dangerouslySetInnerHTML={asHtml ? { __html: content } : undefined}
        >
          {asHtml ? null : content}
        </span>
      ) : null}
    </span>
  );
}

export default Tooltip;
